<template>
  <div
  @click="select"
  :class="{ active: SelectedProdEdit.img.filter(i => i.img === data.img).length }"
  class='ViewImg'>
    <img :src="img">
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/mixins/api'
export default {
  name: 'ViewImg',
  props: ['data'],
  mixins: [api],
  computed: {
    ...mapGetters(['SelectedProdEdit']),
    edit () {
      return this.SelectedProdEdit.id !== ''
    },
    img () {
      return this.api + this.data.img
    }
  },
  methods: {
    ...mapActions(['ChangeProdEdit', 'SetModal', 'CreateProductImage', 'DeleteProductImage']),
    select () {
      let imgs = this.SelectedProdEdit.img
      if(imgs.filter(i => i.img === this.data.img).length) {
        //api- db
        if(this.edit) {
          this.DeleteProductImage({img: this.data, prodid: this.SelectedProdEdit.id})
        }
        imgs = imgs.filter(i => i.img !== this.data.img)
        this.ChangeProdEdit({ img: imgs })
      }
      else {
        //api - db
        if(this.edit) {
        this.CreateProductImage({ img: this.data.img, prodid: this.SelectedProdEdit.id })
          .then(id => {
            imgs.push({ img: this.data.img, id: id })
            this.ChangeProdEdit({ img: imgs })
          })
        }
        else {
          imgs.push({ img: this.data.img, id: 0 })
          this.ChangeProdEdit({ img: imgs })
        }
      }
    }
  }
}
</script>

<style scoped>
.ViewImg {
  margin: 5px;
  border: 3px solid #CCCCCC;
  cursor: pointer;
}

img {
  width: 100px;
  height: 100px;
}

.active {
  border: 3px solid #648EEA;
}
</style>
